import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconFolder1"><Path d="M4.5 3C3.11929 3 2 4.11929 2 5.5V17.5C2 18.8807 3.11929 20 4.5 20H19.5C20.8807 20 22 18.8807 22 17.5V8.5C22 7.11929 20.8807 6 19.5 6H13.0704C12.5688 6 12.1005 5.74935 11.8223 5.33205L11.0098 4.11325C10.5461 3.41775 9.76551 3 8.92963 3H4.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder1;
